"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEText = void 0;

var _react = _interopRequireDefault(require("react"));

require("./FAEText.scss");

const _excluded = ["heading", "subHeading", "children", "primary", "secondary", "tertiary", "bold", "paragraph", "className", "important", "light"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEText = _ref => {
  let {
    heading,
    subHeading,
    children,
    primary,
    secondary,
    tertiary,
    bold = "",
    paragraph,
    className = "",
    important,
    light
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const textType = heading ? "heading" : subHeading ? "sub-heading" : paragraph ? "paragraph" : "";
  const textColor = primary ? "primary-text-color" : secondary ? "secondar-text-color" : tertiary ? "tertiary-text-color" : "";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", _extends({
    className: "fae--text ".concat(className, " ").concat(textType, " ").concat(textColor, " ").concat(bold && "bold", " ").concat(light && "light")
  }, rest), children, " ", important && /*#__PURE__*/_react.default.createElement("span", {
    className: "error"
  }, "*")));
};

exports.FAEText = FAEText;